<div
  class="container"
  [style.transform]="
    'translate(' + translateX + 'px, ' + translateY + 'px' + ')'
  "
>
  <header>
    <div
      class="topHeader"
      [ngClass]="{ active: isDragged }"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp()"
      (mousemove)="onMouseMove($event)"
    >
      <ng-content select="[container-header]"></ng-content>
      <div class="icons">
        <animated-x-btn (click)="close()"></animated-x-btn>
      </div>
    </div>
  </header>
  <section>
    <ng-content select="[container-body]"></ng-content>
  </section>
</div>
